// @flow
import axios from 'lib/defaultClient';

export const getForMe = (payload) => axios.post(`/me/wish`, payload);
export const getAsNonRegisteredForMe = (payload) => axios.post(`/me/non-registered/wish`, payload);
export const addItemForMe = (payload) => axios.post(`/me/wish/items`, payload);
export const emptyForMe = () => axios.delete('/me/wish/items');
export const countItemsForMe = () => axios.get(`/me/wish/items/count`);
export const deleteItemForMe = (index, itemId) => axios.delete(`/me/wish/items/${itemId}`);
export const updateItemForMe = (index, itemId, payload) => axios.put(`/me/wish/items/${itemId}`, payload);
export const checkoutForMe = (payload) => axios.post(`/me/wish/checkout/order`, payload);
export const checkoutAsNonRegisteredForMe = (payload) => axios.post(`/me/non-registered/wish/checkout/order`, payload);




// WEBPACK FOOTER //
// ./src/lib/api/me/wish.js